import {FormControlLabel} from "@mui/material";

import { styled } from "@mui/system";

// テーブル用
export const BaseFormControlLabel = styled(FormControlLabel)(() => (
    {
        "& .MuiFormControlLabel-label": {
            fontSize: "0.9rem",
        }
    }));

// メールボックス同意チェック
export const MailCheckFormControlLabel = styled(FormControlLabel)(() => (
    {
        marginTop: "15px",
        display: "flex",      
        justifyContent: "center", 
        width: "100%", 
    }));